export default __webpack_public_path__ + "static/media/img6.40919ed2.png";